<template>
    <Spinner v-if="displaySpinner" />
    <Password v-model="password" :fluid="true" :feedback="false" />
    <Button label="Authenticate" @click="() => reAuthenticateAndClose()" />
</template>

<script setup lang="ts">
import { inject, Ref, ref } from "vue";
import { useAuthenticationStore } from "@/stores/authentication-store";
import Spinner from "@/shared/Spinner.vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useToast } from "primevue/usetoast";

const { reAuthenticateEmailAndPassword } = useAuthenticationStore();
const toast = useToast();
const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");
const password = ref("");
const displaySpinner = ref(false);
const { successCallback, failureCallback } = dialogRef!.value.data;

const close = () => dialogRef!.value.close();
const reAuthenticateAndClose = async () => {
    displaySpinner.value = true;
    try {
        await reAuthenticateEmailAndPassword(password.value);
        successCallback();
        close();
    } catch {
        toast.add({
            severity: "error",
            summary: "Reauhtentication failed.",
        });
        failureCallback();
    } finally {
        displaySpinner.value = false;
    }
};
</script>
